<template>
  <div class="padding-zero">
    <div class="searchPanel">
      <div class="flex-inline">
        <span class="toggle" v-if="toggleOption">
          <i
            class="fas fa-toggle-on"
            v-if="!toggleValue"
            @click="handleToggle()"
          ></i>
          <i
            class="fas fa-toggle-off"
            v-if="toggleValue"
            @click="handleToggle()"
          ></i>
        </span>
        <h1 class="title">
          {{ title }}
          <span style="margin-left: 5rem" v-if="titleExtraInfo">{{
            titleExtraInfo
          }}</span>
        </h1>
        <div
          class="spinner-border text-secondary loader"
          role="status"
          v-show="loading === true"
        >
          <span class="sr-only">Loading...</span>
        </div>
      </div>

      <div class="flex-inline">
        <div>
          <input
            v-if="extraInputLabel"
            type="text"
            :placeholder="extraInputLabel"
            style="border-radius: 10px"
            class="form-control extraInput"
            v-model="extraInput"
            @change="handleEmitParam(extraInput)"
          />
        </div>

        <div class="dateFieldSwitch" v-if="dates && dateFields">
          <label
            v-for="dateField in dateFields"
            :key="dateField.name"
            class="dateFieldOption"
          >
            <input
              type="radio"
              :value="dateField.name"
              v-model="selectedDateField"
            />
            {{ dateField.displayName }}
          </label>
        </div>

        <div class="datepickers" v-if="dates">
          <datepicker
            :monday-first="true"
            :language="pl"
            v-model="selectedDateFrom"
            name="dateFrom"
            :placeholder="'Data od'"
          ></datepicker>
          <datepicker
            :monday-first="true"
            :language="pl"
            v-model="selectedDateTo"
            name="dateTo"
            :placeholder="'Data do'"
          ></datepicker>
        </div>
        <div class="clearDates" v-if="dates">
          <button
            class="btn btn-outline-dark clearButton"
            v-if="dates"
            @click="clearDates()"
          >
            Wyczyść daty
          </button>
        </div>

        <div>
          <button
            class="btn btn-outline-dark firstAdditionalButton"
            v-if="firstAdditionalButton"
            @click="emitFirstMethod()"
            :disabled="disabledFirstAdditionalButton"
          >
            {{ firstAdditionalButton }}
          </button>
        </div>

        <div>
          <button
            class="btn btn-outline-dark secondAdditionalButton"
            v-if="secondAdditionalButton"
            @click="emitSecondMethod()"
            :disabled="disabledSecondAdditionalButton"
          >
            {{ secondAdditionalButton }}
          </button>
        </div>

        <div>
          <button
            class="btn btn-outline-dark thirdAdditionalButton"
            v-if="thirdAdditionalButton"
            @click="emitThirdMethod()"
            :disabled="disabledThirdAdditionalButton"
          >
            {{ thirdAdditionalButton }}
          </button>
        </div>
      </div>

      <div class="searchUserPanel" v-if="!withoutSearchInput">
        <form @submit.prevent="handleDispatchAction()">
          <div class="inner-addon left-addon">
            <svg
              class="searchIcon"
              width="40"
              height="35"
              viewBox="0 0 30 29"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g opacity="0.3" clip-path="url(#clip0)">
                <path
                  d="M26.8421 28.9995C26.5263 28.9995 26.2105 28.9995 25.8947 28.9995C25.5947 28.8 25.2474 28.6619 24.9947 28.4164C23.2579 26.7593 21.5368 25.0868 19.8158 23.4143C19.3263 22.954 19.0737 22.3249 19.3263 21.7418C19.6105 21.0974 19.3579 20.7598 18.9158 20.3915C18.6947 20.2074 18.4737 20.0233 18.3 19.7931C17.9211 19.3175 17.6053 19.3175 17.0684 19.655C11.8421 22.9693 4.76842 21.3582 1.56316 16.1566C0.742105 14.837 0.363158 13.3794 0 11.9064C0 11.1392 0 10.3873 0 9.62011C0.0473684 9.42064 0.126316 9.23652 0.157895 9.03704C0.852632 4.63334 4.32632 1.15027 8.92105 0.214293C13.2789 -0.675654 18.0316 1.24234 20.3842 4.95556C22.8316 8.83757 22.7368 12.7503 20.2895 16.6169C20.1474 16.8318 19.8316 17.0312 20.1474 17.3381C20.6368 17.8138 21.1105 18.2741 21.6 18.7497C21.7737 18.9185 21.9158 18.8418 22.1053 18.7804C23.0368 18.4122 23.7632 18.6884 24.4421 19.3482C25.9263 20.8212 27.4421 22.2788 28.9579 23.7212C29.3684 24.1201 29.7316 24.5344 30 25.0407C30 25.3476 30 25.6545 30 25.9614C29.1947 27.2042 28.1368 28.2169 26.8421 28.9995ZM11.0368 18.3815C15.4263 18.3968 18.9632 15.0058 18.9789 10.7556C18.9947 6.5053 15.4895 3.06826 11.1158 3.05292C6.69474 3.03757 3.15789 6.39789 3.12632 10.6482C3.09474 14.9445 6.6 18.3661 11.0368 18.3815Z"
                  fill="#090741"
                />
                <path
                  d="M15.3001 8.13255C15.2528 8.6389 15.0159 9.06853 14.4949 9.31404C13.9738 9.55954 13.437 9.55954 13.0107 9.20663C11.7001 8.10187 10.4528 8.13255 9.14223 9.22197C8.5896 9.68229 7.78434 9.52885 7.29486 9.0225C6.82118 8.5315 6.7896 7.7643 7.23171 7.21192C8.92118 5.06377 13.358 5.07911 15.0001 7.24261C15.1896 7.50345 15.3001 7.77964 15.3001 8.13255Z"
                  fill="#090741"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect width="30" height="29" fill="white" />
                </clipPath>
              </defs>
            </svg>

            <input
              type="text"
              placeholder="Szukaj..."
              style="border-radius: 10px"
              class="form-control searchBlock tableSearchBlock"
              v-model="selectedParam"
            />
          </div>
        </form>
      </div>
    </div>

    <div class="header">
      <div class="pagination" v-if="withPagination">
        <pagination-inline
          :dispatchAction="dispatchAction"
          :onPage="onPage"
          :pageNumber="pageNumber"
          :total="total"
          :filterParam="selectedFilter"
          :secondFilterParam="selectedSecondFilter"
          :thirdFilterParam="selectedThirdFilter"
          :searchParam="selectedParam"
          :dateFrom="dateFromParam"
          :dateTo="dateToParam"
          :dateField="selectedDateField"
          v-model="loading"
        ></pagination-inline>
      </div>
      <div class="actionIcons">
        <slot name="extra-content"> </slot>
        <div @click="emitFirstMethod()" v-if="!checked && checkbox">
          <i class="far fa-square"></i>
        </div>
        <div @click="emitFirstMethod()" v-if="checked && checkbox">
          <i class="fas fa-check-square"></i>
        </div>

        <div @click="handleDispatchAction()" v-if="refreshAction">
          <i class="fas fa-sync-alt refresh-list-icon"></i>
        </div>

        <div v-if="downloadAction" @click="downloadTableData()">
          <i class="fas fa-download"></i>
        </div>
        <div @click="emitSecondMethod()" v-if="checkAction">
          <i class="fas fa-check"></i>
        </div>
      </div>
      <div
        v-if="downloadAction"
        class="checkbox-wrapper flex items-center content-center"
      >
        <div v-if="withDownloadCheckbox">
          <input id="shorterExport" v-model="shorterExport" type="checkbox" />
          <label for="shorterExport" class="p-4 mt-2"
            >Eksportuj tylko ID i NR TEL</label
          >
        </div>
      </div>

      <div class="allFilters">
        <div class="filters p-0" v-if="withFilters">
          <Select
            :filters="filters"
            @refreshFilters="handleFilters('', $event)"
          ></Select>
        </div>
        <div class="filters p-0" v-if="withSecondFilters">
          <Select
            :filters="secondFilters"
            @refreshFilters="handleSecondFilters('', $event)"
          ></Select>
        </div>
        <input
          id="secondFilterSelect"
          type="text"
          :value="selectedSecondFilter"
        />

        <div class="filters p-0" v-if="withThirdFilters">
          <Select
            :filters="thirdFilters"
            :label="thirdFiltersLabel"
            @refreshFilters="handleThirdFilters('', $event)"
          ></Select>
        </div>
      </div>
    </div>
    <div v-if="(!total || total == 0) && !loading" class="notFoundListAlert">
      Brak danych
    </div>
  </div>
</template>

<script>
import PaginationInline from "./PaginationInline.vue";
import Select from "./Select.vue";
import Datepicker from "vuejs-datepicker";
import shared from "../shared";
import { pl } from "vuejs-datepicker/dist/locale";
export default {
  name: "TableHeader",

  components: { PaginationInline, Select, Datepicker },
  props: [
    "title",
    "titleExtraInfo",
    "withFilters",
    "withActions",
    "withPagination",
    "filters",
    "dispatchAction",
    "toggleDispatchAction",
    "onPage",
    "pageNumber",
    "total",
    "filterParam",
    "searchParam",
    "withIcons",
    "selectAction",
    "refreshAction",
    "downloadAction",
    "withSecondFilters",
    "secondFilters",
    "withThirdFilters",
    "thirdFilters",
    "tableName",
    "checkAction",
    "confirmActionMessage",
    "checkbox",
    "firstAdditionalButton",
    "secondAdditionalButton",
    "thirdAdditionalButton",
    "disabledFirstAdditionalButton",
    "disabledSecondAdditionalButton",
    "disabledThirdAdditionalButton",
    "extraInputLabel",
    "dates",
    "thirdFiltersLabel",
    "dateFields",
    "toggleOption",
    "toggleValue",
    "withoutSearchInput",
    "withDownloadCheckbox",
    "emitRefresh",
  ],

  created() {
    if (this.total) {
      this.loading = false;
    }
  },
  mounted() {
    if (this.$router.currentRoute.query.search) {
      setTimeout(() => {
        this.handleDispatchAction();
      }, 500);
    }
    
    setTimeout(() => {
      if (this.loading) {
        this.loading = false;
      }
    }, 1000);
  },
  data() {
    return {
      pl: pl,
      toggle: false,
      selectedFilter: this.filters ? this.filters[0].name : "",
      selectedSecondFilter: this.secondFilters
        ? this.secondFilters[0].name
        : "",
      selectedThirdFilter: this.thirdFilters ? this.thirdFilters[0].name : "",
      selectedParam: this.$route.query.search
        ? this.$route.query.search
        : this.$route.params.id
        ? this.$route.params.id
        : "",
      loading: true,
      checked: false,
      extraInput: "",
      selectedDateFrom: null,
      selectedDateTo: null,
      selectedDateField: this.dateFields ? this.dateFields[0].name : "",
      firstEmitMethodParam: "",
      secondEmitMethodParam: "",
      shorterExport: false,
    };
  },

  computed: {
    // Timestampy zakresu dat w jednym miejscu - używane zarówno przy zmianie
    // filtrów, jak i przekazywane do paginacji, żeby przejście na kolejną stronę
    // zachowało ten sam zakres.
    dateFromParam() {
      return this.selectedDateFrom
        ? Date.parse(shared.startOfDayFromTimestampDate(this.selectedDateFrom))
        : null;
    },
    dateToParam() {
      return this.selectedDateTo
        ? Date.parse(shared.startOfDayFromTimestampDate(this.selectedDateTo))
        : null;
    },
  },

  methods: {
    handleToggle() {
      if (!this.loading) {
        this.$emit("handleToggle");
      }
    },

    clearDates() {
      (this.selectedDateFrom = null), (this.selectedDateTo = null);
      this.handleDispatchAction();
    },

    downloadTableData() {
      this.$store.dispatch("downloadTableData", {
        tableName: this.tableName,
        filter: this.selectedFilter,
        secondFilter: this.selectedSecondFilter,
        thirdFilter: this.selectedThirdFilter,
        searchParam: this.selectedParam,
        dateFrom: this.dateFromParam,
        dateTo: this.dateToParam,
        dateField: this.selectedDateField,
        shorterExport: this.shorterExport,
      });
    },

    async handleDispatchAction(setActualPage) {
      const dispatch = !this.toggle
        ? this.dispatchAction
        : this.toggleDispatchAction;
      this.loading = true;
      await this.$store.dispatch(dispatch, {
        on_page: this.onPage,
        page_number: setActualPage ? this.pageNumber : 1,
        filter_param: this.selectedFilter,
        second_filter_param: this.selectedSecondFilter,
        third_filter_param: this.selectedThirdFilter,
        search_param: this.selectedParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam,
        date_field: this.selectedDateField,
      });

      this.loading = false;
    },

    handleFilters(i, filter) {
      this.selectedFilter = filter;
      this.handleDispatchAction();
    },

    handleEmitParam(param) {
      this.secondEmitMethodParam = param;
      this.firstEmitMethodParam = param;
    },

    handleSecondFilters(i, filter) {
      this.selectedSecondFilter = filter;
      this.selectedFilter = "";
      this.selectedThirdFilter = "";
      this.handleDispatchAction();
    },

    handleThirdFilters(i, filter) {
      this.selectedThirdFilter = filter;
      this.handleDispatchAction();
    },

    emitFirstMethod() {
      this.checked = !this.checked;
      this.$emit("firstMethodToListen", {
        emitParam: this.secondEmitMethodParam,
        on_page: this.onPage,
        page_number: this.pageNumber,
        filter_param: this.selectedFilter,
        second_filter_param: this.selectedSecondFilter,
        third_filter_param: this.selectedThirdFilter,
        search_param: this.selectedParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam,
      });
      this.firstEmitMethodParam = "";
      this.extraInput = "";
    },
    emitSecondMethod() {
      if (this.confirmActionMessage) {
        if (confirm(this.confirmActionMessage)) {
          this.$emit("secondMethodToListen", {
            emitParam: this.secondEmitMethodParam,
            on_page: this.onPage,
            page_number: this.pageNumber,
            filter_param: this.selectedFilter,
            second_filter_param: this.selectedSecondFilter,
            third_filter_param: this.selectedThirdFilter,
            search_param: this.selectedParam,
            date_from: this.dateFromParam,
            date_to: this.dateToParam,
          });
          this.secondEmitMethodParam = "";
          this.extraInput = "";
        }
      } else {
        this.$emit("secondMethodToListen", {
          emitParam: this.secondEmitMethodParam,
          on_page: this.onPage,
          page_number: this.pageNumber,
          filter_param: this.selectedFilter,
          second_filter_param: this.selectedSecondFilter,
          third_filter_param: this.selectedThirdFilter,
          search_param: this.selectedParam,
          date_from: this.dateFromParam,
          date_to: this.dateToParam,
        });
        this.secondEmitMethodParam = "";
        this.extraInput = "";
      }
    },
    emitThirdMethod() {
      this.checked = !this.checked;
      this.$emit("thirdMethodToListen", {
        emitParam: this.thirdEmitMethodParam,
        on_page: this.onPage,
        page_number: this.pageNumber,
        filter_param: this.selectedFilter,
        second_filter_param: this.selectedSecondFilter,
        third_filter_param: this.selectedThirdFilter,
        search_param: this.selectedParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam,
      });
      this.thirdEmitMethodParam = "";
      this.extraInput = "";
    },
  },

  watch: {
    emitRefresh() {
      this.handleDispatchAction(true);
    },
    selectedParam() {
      this.$emit("selectedParam", {
        selectedParam: this.selectedParam,
      });
      if (this.selectedParam.length === 9 || this.selectedParam.length === 0) {
        if (this.selectedParam.length === 9) {
          this.$router.push({
            path: this.$route.path,
            query: { search: this.selectedParam },
          });
        }
        if (this.selectedParam.length === 0) {
          this.$router.push({
            path: this.$route.path,
          });
        }
        this.handleDispatchAction();
      }
    },
    selectedDateFrom() {
      if (this.selectedDateTo && this.selectedDateFrom) {
        this.handleDispatchAction();
      }
    },
    selectedDateTo() {
      if (this.selectedDateFrom && this.selectedDateTo) {
        this.handleDispatchAction();
      }
    },
    // Przełączenie pola daty zmienia wynik tylko wtedy, gdy zakres jest ustawiony.
    selectedDateField() {
      if (this.selectedDateFrom && this.selectedDateTo) {
        this.handleDispatchAction();
      }
    },

    total(cur) {
      if (cur) {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.toggle {
  margin-right: 10px;
}
.toggle i {
  font-size: 18px;
  cursor: pointer;
}
#secondFilterSelect {
  display: none;
}
.table-container {
  min-width: 100%;
}
.header {
  padding: 0;
  display: flex;
  background: #f7f8f9;
  color: #93a3ad;
  height: auto;
  min-height: 50px;
  border-radius: 18px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;

  -webkit-box-shadow: 0px 0px 30px 5px rgba(176, 176, 176, 1);
  -moz-box-shadow: 0px 0px 30px 5px rgba(176, 176, 176, 1);
  box-shadow: 0px 0px 30px 5px rgba(176, 176, 176, 1);
  flex-wrap: wrap;
  justify-content: space-between;
  font-size: 11px;
  align-items: center;
}

.allFilters {
  max-width: 60%;
}
.filters {
  flex-wrap: wrap;
  margin-right: 10px;
}

.filters div {
  position: relative;
}

.filters div:last-child {
  margin-right: 15px;
}
.filters div:hover {
  color: #090741;
}
.filters img {
  margin-right: 15px;
  height: 20px;
}
.header div {
  padding: 5px 10px 5px 10px;
  display: flex;
  align-items: center;
  text-align: center;
  height: 100%;

  min-height: 50px;
}
.selectedFilterMark {
  bottom: 0;
  position: absolute;
  width: 80%;
  border-bottom: 3px solid #5196d3;
}
.actionIcons div {
  margin: 0;
  height: 20px;
  cursor: pointer;
  border: 1px solid #e5e5e9;
  padding: 5px 20px 5px 20px;
  color: #cccccf;
  min-height: 30px;
}
.actionIcons div:hover {
  color: #000;
}
.top {
  margin: 10px 10px;
  display: flex;
  flex-direction: column;
  padding-top: 10px;
}
.rooms-wrapper {
  display: flex;
  justify-content: space-around;
}
.rooms-grey {
  background-color: #e2e1e1c4;
}
.rooms-white {
  background-color: white;
}

.flags {
  display: flex;
  align-items: center;
}
.flags i {
  margin-left: 15px;
}

.flagIcon {
  font-size: 15px;
  margin-right: 10px;
}
.searchPanel h1 {
  margin-bottom: 0;
  margin-right: 20px;
}
.searchPanel {
  display: flex;
  align-items: center;
  min-height: 80px;
  justify-content: space-between;
}
.searchUserPanel {
  display: flex;
  align-items: center;
}
.searchUserPanel input {
  border-radius: 50px !important;
  background: #f2f2f2;
  color: #090741;
  height: 32px;
  font-size: 13px;
}
.inner-addon {
  position: relative;
}

/* style icon */
.inner-addon .searchIcon {
  position: absolute;
  padding: 10px;
  pointer-events: none;
}

/* add padding  */
.left-addon input {
  padding-left: 30px;
}
select:focus {
  outline: none !important;
  background: white !important;
}
select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none; /* Remove default arrow */
  border: none;
  margin-left: 32px;
}
select option {
  border: none;
}
ul {
  border: none;
}
.title {
  min-width: 100px;
}
.extraInput {
  margin-left: 80px;
  margin-right: 10px;
  width: auto;
  min-width: 200px;
  background: #f2f2f2;
}

.dateFieldSwitch {
  display: flex;
  flex-direction: column;
  margin-right: 10px;
  white-space: nowrap;
}
.dateFieldOption {
  display: flex;
  align-items: center;
  gap: 5px;
  margin: 0;
  font-size: 12px;
  cursor: pointer;
}
.dateFieldOption input {
  cursor: pointer;
  margin: 0;
}

.clearDatesButton {
  position: absolute;
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 0;
  padding-top: 0;
}
.clearDatesButton button {
  margin: 0;
  width: 50%;
  height: 20px;
  font-size: 8px;
  text-align: center;
}
.flex-inline {
  display: flex;
  align-items: center;
}
</style>
